import { NgModule } from '@angular/core';
import { ToastComponent } from './components/toast.component';
import { CommonModule } from '@angular/common';
import { ToastContainerComponent } from './v2/components/toast-container/toast-container.component';
import { ToastV2Component } from './v2/components/toast/toast.component';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [ToastComponent, ToastContainerComponent, ToastV2Component],
  imports: [CommonModule, IconModule, ButtonModule, TranslocoModule],
  exports: [ToastContainerComponent],
})
export class ToastModule {}
